__turbopack_context__.v({
  "box": "Onkormanyzat-module__wZBcUW__box",
  "default": "Onkormanyzat-module__wZBcUW__default",
  "main": "Onkormanyzat-module__wZBcUW__main",
});
